/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CreatePlayerMobile200Response
 */
export interface CreatePlayerMobile200Response {
    /**
     * A message indicating the success of the operation
     * @type {string}
     * @memberof CreatePlayerMobile200Response
     */
    message?: string;
    /**
     * The player number of the newly created player
     * @type {string}
     * @memberof CreatePlayerMobile200Response
     */
    playerNumber?: string;
}


/**
 * Check if a given object implements the CreatePlayerMobile200Response interface.
 */
export function instanceOfCreatePlayerMobile200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function CreatePlayerMobile200ResponseFromJSON(json: any): CreatePlayerMobile200Response {
    return CreatePlayerMobile200ResponseFromJSONTyped(json, false);
}

export function CreatePlayerMobile200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlayerMobile200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
    };
}

export function CreatePlayerMobile200ResponseToJSON(value?: CreatePlayerMobile200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
        'playerNumber': value.playerNumber,
    };
}

